import { inject } from '@angular/core';

import { APP_STORE } from '@core/stores/app.store';

export const ACCOUNT_CAN_ACTIVATE_GUARD = (): boolean => hasAccount();

export const ACCOUNT_CAN_MATCH_GUARD = (): boolean => hasAccount();

const hasAccount = (): boolean => {
  const appStore = inject(APP_STORE);

  return !!appStore.selectedAccountId();
};
